var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goTop-wrap"},[(_vm.activeShow)?_c('div',{ref:"goTop",staticClass:"goTop",style:({ right: _vm.right }),on:{"click":_vm.gotoTop}},[_c('i',{staticClass:"icon-sohu-lujing"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }